import { Listeartikel } from '@/modules/ewwms/models/Lager/ListeartikelModels';

export type State = {
  bestand: Array<Listeartikel>;
};

export const state: State = {
  bestand: sessionStorage.getItem('bestand') != null ? JSON.parse(sessionStorage.bestand) : new Array<Listeartikel>(),
};
